<template>
    <v-checkbox
        ref="filterToDoc"
        v-model="filterDoc"
        :readonly="disableElements"
        label="Filter Doctors by Specialization"
        @change="handleChangeToFilterDoc($event)"
    />
</template>

<script>
import { mapActions } from 'vuex'

export default {
    props: ['disableElements', 'to'],
    data: () => ({
        filterDoc: null
    }),
    watch: {
        'to.filter.doc'(newVal) {
            this.filterDoc = newVal
        }
    },
    methods: {
        ...mapActions(['toDoctors']),
        handleChangeToFilterDoc(value) {
            this.to.filter.doc = value
            if (!value) this.to.specField = { sp_name: 'ALL', sp_desc: '' }
            this.to.hospClinType = 'H'
            this.to.decking = ''
            if (this.to.facility && !value) {
                this.to.hospClinDoctor = ''
                this.to.hospClinType = 'H'
                this.to.hospClinDoctorCode = null
                this.toDoctors({ PTYPE: '', HOSP_MSU: this.to.facility && this.to.facility.hosp_msu_code, SPEC: this.to.specField && this.to.specField.sp_desc })

            }
        }
    }
}
</script>
